import React from 'react';
import Navbar from './Navbar';
import PageHeader from './PageHeader';

interface PageLayoutProps {
    children: React.ReactNode;
    title?: string;
    titleKey?: string;
    displayBackButton?: boolean;
}
const PageLayout: React.FC<PageLayoutProps> = ({ children, title, titleKey, displayBackButton = true }) => {
    return (
        <div className="bg-[#F5F3F0] text-[#42403C] flex flex-col h-screen">
            <PageHeader title={title} titleKey={titleKey} displayBackButton={displayBackButton} />
            <div className="flex-1 overflow-y-auto px-1 pt-12">
                {children}
            </div>
            <Navbar />
        </div>
    );
};

export default PageLayout;
